import { useContext } from "react";
import { ProjectAndDeploymentIdsContext } from "contexts/project-and-deployment-ids-context";

/** Returns the ID of the current (or most recently-viewed) deployment, if any */
export const useCurrentDeploymentId = () => useContext(ProjectAndDeploymentIdsContext)[1];
